import styled from "styled-components";
import { Helmet } from "react-helmet-async";
import { PageSection, PageTitle, PageSubtitle, Paragraph } from "../components/PageLayout";

const OrderedList = styled.ol`
  margin: 0 0 24px 22px;
  padding: 0;
  line-height: 1.6;
`;

function Privacy() {
  return (
    <main id="main-content">
      <Helmet>
        <title>Texmu Privacy Policy</title>
        <meta name="description" content="How Texmu handles and protects your data." />
      </Helmet>
      <PageSection>
        <PageTitle>Privacy Policy for Texmu</PageTitle>
        <PageSubtitle>Last Updated: 2025-10-30</PageSubtitle>
        <Paragraph>
          At Texmu (“we”, “us”, “our”), your privacy is important to us. This Privacy Policy explains how we handle information when you use our browser extension (“Software”, “Extension”).
        </Paragraph>
        <OrderedList>
          <li>
            <strong>Local Processing</strong>
            <Paragraph as="p">
              All text analysis and classification performed by Texmu occurs entirely on your device. The Software does not send website content, personal data, or browsing activity to external servers. The detection logic operates within your browser session only.
            </Paragraph>
          </li>
          <li>
            <strong>Data We Store</strong>
            <Paragraph as="p">
              <strong>User Preferences:</strong> Texmu stores limited configuration data (e.g., enabled/disabled status, word blacklist entries, topic groups, optional CSS selectors, per-site whitelist/blacklist, blur intensity). This information is stored locally via browser storage APIs (chrome.storage.local or equivalent).
            </Paragraph>
            <Paragraph as="p">
              <strong>No Personal Data Collection:</strong> We do not collect personally identifiable information (PII), browsing history, or usage analytics.
            </Paragraph>
          </li>
          <li>
            <strong>Communication</strong>
            <Paragraph as="p">
              If you contact us at solocreater8919@gmail.com, any personal information you voluntarily provide (such as your name, email address, or details about your issue) will be used solely to respond to your inquiry. We do not share, sell, or rent such information to third parties.
            </Paragraph>
          </li>
          <li>
            <strong>Third-Party Websites</strong>
            <Paragraph as="p">
              Texmu interacts with third-party websites by scanning and optionally blurring text content. We are not responsible for the content, policies, or practices of external websites you visit. This Privacy Policy applies only to the Texmu extension, not to third-party websites.
            </Paragraph>
          </li>
          <li>
            <strong>Security</strong>
            <Paragraph as="p">
              We take reasonable measures to protect user settings stored in the browser. However, no software or data storage system is completely secure. By using the Software, you acknowledge and accept this risk.
            </Paragraph>
          </li>
          <li>
            <strong>Updates to This Policy</strong>
            <Paragraph as="p">
              We may update this Privacy Policy from time to time. Any changes will be reflected with a revised “Last Updated” date at the top of this page. Continued use of Texmu after updates indicates your acceptance of the revised Privacy Policy.
            </Paragraph>
          </li>
        </OrderedList>
      </PageSection>
    </main>
  );
}

export default Privacy;
